import { useMemo } from "react";
import { useQuery } from "@apollo/client";

import { SESSIONS_POLL_INTERVAL_MS } from "../constants";
import { conciergeParkedByLot } from "./queries";

export default function useParkedByLot(installationId) {
  const { data, loading, error, refetch } = useQuery(conciergeParkedByLot, {
    variables: { installationId },
    skip: !installationId,
    fetchPolicy: "cache-and-network",
    pollInterval: SESSIONS_POLL_INTERVAL_MS,
  });
  const rawLots = data?.allLots;

  const lots = useMemo(
    () =>
      (rawLots ?? []).filter(Boolean).map((lot) => ({
        ...lot,
        capacity: Number.isFinite(lot.capacity) ? lot.capacity : null,
        occupied: Number.isFinite(lot.currentValetSessionCount)
          ? lot.currentValetSessionCount
          : 0,
      })),
    [rawLots],
  );

  return {
    lots,
    loading: loading && !rawLots,
    error,
    refetch,
  };
}
